<template>
  <div>
    <a-card :bordered="false" style="">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24" style="margin:16px 25px;">
             <a-col class="a-large-form">
              <a-form-item style="margin-bottom:0px" label="" :required="false">
                <a-select defaultValue="全部角色">
                  <a-select-option value>全部角色</a-select-option>
                  <a-select-option value="0">管理员</a-select-option>
                  <a-select-option value="1">助教</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="a-large-form">
              <a-form-item style="margin-bottom:0px" label="" :required="false">
                <a-select defaultValue="全部状态">
                  <a-select-option value>全部状态</a-select-option>
                  <a-select-option value="0">启用</a-select-option>
                  <a-select-option value="1">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-button type="primary" style="margin-left:10px;float:right;">新增员工</a-button>
          </a-row>
          
        </a-form>
      </div>
      <div>
        <a-table
          ref="table"
          size="middle"
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a @click="handleEdit(record)">删除</a>
          
          </span>
        </a-table>
        
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'StaffAccountList',
  // mixins: [],
  data() {
    return {
      selectedData: [],
      // 表头
      description: '员工账号管理页面',
      loading:false,
      columns: [
        {
          title: '账号',
          align: 'center',
          dataIndex: 'studentName'
        },
        {
          title: '员工名称',
          align: 'center',
          dataIndex: 'origin'
        },
        {
          title: '角色',
          align: 'center',
          dataIndex: 'mobile'
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'school'
        },
        {
          title: '最后登录时间',
          align: 'center',
          dataIndex: 'registDate'
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'lastLoginTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align:"center",
          width:150,
          scopedSlots: { customRender: 'action' },
        }
      ],
      dataSource: [
        {
          studentName: '赵四',
          origin: '程晓芳',
          mobile: '管理员',
          school: '2019/09/09 09:09:09',
          registDate: '2019/08/08 08:08:08',
          lastLoginTime: '启用',
          mobile: '18989898989',
          origin: '线上',
          studentName: '李四'
        }
      ]
    }
  },
  methods: {
    courseCreate() {
      this.$router.push({ path: '/myCourse/courseCreate' })
    }
  },
  computed: {
    
  }
}
</script>

<style scoped>
@import '~@assets/less/common.less';
</style>

<style lang="scss" scoped >
.total-data {
  .total-data-item {
    float: left;
    width: 50%;
    margin: 10px 0px;
    &:first-child {
      border-right: 1px solid #e7ecef;
    }
    .p1 {
      text-align: center;
      font-size: 14px;
      color: #333333;
    }
    .p2 {
      text-align: center;
      color: #fa6400;
      font-size: 40px;
    }
  }
}
.fixed-tab-con {
  // display: none;
  height: 70px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
  position: fixed;
  bottom: 0px;
  left: 0px;
  text-align: center;
  width: 100%;
  padding-left: 220px;
  .fixed-tab {
    margin-top: 16px;
  }
}
</style>